import React from 'react';

import Box from '@mui/material/Box';

import { Accordion } from './components/Accordion';

import { faq } from '../../data';

export function Questions({ keyWord }) {
  return (
    <Box sx={{ marginTop: '30px' }}>
      {faq
        .filter(({ category }) => (!keyWord ? category : category === keyWord))
        .map(({ question, answers }) => (
          <Accordion question={question} answers={answers} />
        ))}
    </Box>
  );
}
